import { useContext, useEffect, useState } from 'react';
import Context from '../provider';

/**
 * Custom Hook to detect if an element is scrolling
 * @param {HTMLElement} targetElement The target element to listen for scroll events
 * @returns {boolean} Whether the element is currently scrolling
 */
function useIsScrolling(targetElement) {
    const { dispatch } = useContext(Context);

  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    dispatch({ type: 'SWITCH_SHOW_FLOAT_MENU', payload: { show: !isScrolling } });
  }, [isScrolling]);

  useEffect(() => {
    if (!targetElement) return;

    let scrollTimeout;

    const handleScroll = () => {
      setIsScrolling(true);

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        setIsScrolling(false);
      }, 200); // Adjust the timeout as needed
    };

    targetElement.addEventListener('scroll', handleScroll);

    return () => {
      clearTimeout(scrollTimeout);
      targetElement.removeEventListener('scroll', handleScroll);
    };
  }, [targetElement]);

  return isScrolling;
}

export default useIsScrolling;